<title mat-dialog-title>Auth Digest</title>

<mat-dialog-content>
  <div class="description">
    You are setting up a non-secure protocol for auth. Do you want to continue?
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button color="danger" mat-dialog-close>No</button>
  <button mat-button color="success" [mat-dialog-close]="true">Yes</button>
</mat-dialog-actions>
